import { module } from 'modujs';
import { html } from '../utils/environment';
import { gsap } from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: 'toggle'
        }
    }

    init() {
        // this.toggle(true);

        this.bindKeydown = this.keydown.bind(this);
        window.addEventListener('keydown',this.bindKeydown);
        
    }

    keydown(e) {
        if(e.key == 'Escape') {
            if(html.classList.contains('has-menu-open')) {
                this.toggle();
            }
        }
    }

    toggle(firstHit = false) {
        html.classList.toggle('has-menu-open');

        if(html.classList.contains('has-menu-open')) {
            if(firstHit) {
                gsap.delayedCall(0.3, () => {
                    this.call('launch',{},'Rail','menuOne');
                    this.call('launch',{},'Rail','menuTwo');
                    this.call('launch',{},'Rail','menuThree');

                    this.call('trigger',{mode:'enter'},'Tagline','menu');

                })
            } else {
                this.call('launch',{},'Rail','menuOne');
                this.call('launch',{},'Rail','menuTwo');
                this.call('launch',{},'Rail','menuThree');

                this.call('trigger',{mode:'enter'},'Tagline','menu');
            }
        } else {
            this.call('trigger',{mode:'leave'},'Tagline','menu');
            this.call('mouseleave',{e:null},'Tagline','menu');
            this.call('pause',{},'Rail','menuOne');
            this.call('pause',{},'Rail','menuTwo');
            this.call('pause',{},'Rail','menuThree');
        }
    }

    destroy() {
        html.classList.remove('has-menu-open');
    }
}
